import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";

export class DjPsychoXN extends PIXI.Container implements StageLayer {

    private _items: TimelineSprite[][] = [];
    private _doubleItems: TimelineSprite[][] = [];

    constructor() {
        super();
        this.name = "DjPsychoXNView";

        this.init();
    }

    public playXNAnimation(reelId: number, symId: number, angle: number): TimelineLite {
        const item: TimelineSprite = this._items[reelId][symId],
            doubleItem: TimelineSprite = this._doubleItems[reelId][symId],
            tl: TimelineLite = new TimelineLite();

        tl.add([
            () => {
                item.angle = angle;
                doubleItem.angle = angle;
            },
            item.getAnimationAutoShowHide(true, true),
            doubleItem.getAnimationAutoShowHide(true, true)
        ]);

        return tl;
    }

    private init(): void {
        let item: TimelineSprite,
            doubleItem: TimelineSprite;

        for (let reel: number = 0; reel < DjPsycho.reelsNum; reel++) {
            this._items.push([]);
            this._doubleItems.push([]);
            for (let row: number = 0; row < DjPsycho.rowsNum; row++) {
                item = new TimelineSprite(DjPsycho.assetLoader.getTextures("FX_Arrow_H/FX_Arrow_H_"));
                item.hide();
                item.anchor.set(0.5);
                item.blendMode = PIXI.BLEND_MODES.ADD;
                item.position.set((DjPsycho.reelViewX + (reel * DjPsycho.symbolWidth) + DjPsycho.symbolWidth / 2 + (reel * DjPsycho.padding)), (DjPsycho.reelViewY + (row * DjPsycho.symbolHeight) + (row * DjPsycho.padding)));

                doubleItem = new TimelineSprite(DjPsycho.assetLoader.getTextures("FX_Arrow_H/FX_Arrow_H_"));
                doubleItem.hide();
                doubleItem.anchor.set(0.5);
                doubleItem.blendMode = PIXI.BLEND_MODES.ADD;
                doubleItem.position = item.position;

                this._items[reel].push(item);
                this._doubleItems[reel].push(doubleItem);

                this.addChild(item, doubleItem);
            }
        }
    }
}